import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const PublicPolicyAcknowledgeRedirect = () => {
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      // Redirect to public server-rendered acknowledgment page (no auth required)
      window.location.replace(`/api/policies/acknowledgments/page/${id}`);
    }
  }, [id]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center text-gray-600">
        Redirecting to acknowledgment page...
      </div>
    </div>
  );
};

export default PublicPolicyAcknowledgeRedirect;


